module.exports = __webpack_public_path__ + "img/5_109.d5b9107c.png";